import TextM from "@common/components/text/TextM"
import { HeaderContainerM } from "@common/header/HeaderContainerM"
import { theme } from "@common/theme/theme"
import {
    apiIdle,
    apiRequest,
    apiRequestWithPrerequest,
} from "@data/redux/actions/api"
import { studyProgramsService } from "@data/services/studyProgramsService"
import { useNavigation } from "@react-navigation/native"
import React, { useContext, useEffect, useState } from "react"
import { View } from "react-native"
import { IconButton } from "react-native-paper"
import { connect } from "react-redux"
import { useApiStatus } from "../hooks/useApiStatus"
import { DimensionsContext } from "../utils/mobileUtils"
import StudyProgramDisplayComponent from "./components/StudyProgramDisplayComponent"
import { RevisionProgramScreen } from "../../ports/primary/ui/screens/parent/RevisionProgram/RevisionProgramScreen"
import { parentOnlyBridge } from "../../featureFlags/screenBridge"

/**
 * Study program detail.
 *
 * - mode parent → ports + DS `<RevisionProgramPage>`
 * - élève et tuteur → legacy `StudyProgramDisplayComponent`
 */
const LegacyStudyProgramScreen = (props) => {
    const { id } = props.route.params
    const [fetchedStudyProgram, setFetchedStudyProgram] = useState(null)

    const currentStudyProgram =
        props.studyPrograms?.find((x) => x?.id === id) ??
        props.subscribeUserStudyPrograms?.find((x) => x?.id === id)
    const navigation = useNavigation()
    const dimensions = useContext(DimensionsContext)

    // Fetch study program from API if not found in props
    useEffect(() => {
        if (!currentStudyProgram && id) {
            props.apiRequest(studyProgramsService.getStudyProgram, { id }, {})
        }
    }, [id, currentStudyProgram])

    // Handle API response
    useApiStatus(studyProgramsService.getStudyProgram, null, false, (data) => {
        setFetchedStudyProgram(data)
    })

    const isLoading = props.getStudyProgramRequest
    const studyProgramToDisplay = currentStudyProgram || fetchedStudyProgram

    return (
        <>
            <HeaderContainerM
                style={{
                    justifyContent: "center",
                    paddingRight: 15,
                    flexDirection: "row",
                }}
            >
                <IconButton
                    icon={"arrow-left"}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={30}
                    style={{
                        position: "absolute",
                        left: 4,
                    }}
                    onPress={() => {
                        if (navigation.canGoBack()) navigation.goBack()
                        else navigation.replace("menu")
                    }}
                />
                <TextM
                    fontSize={20}
                    fontWeight={"ExtraBold"}
                    color={theme.colors.primary}
                    style={{ textAlign: "center" }}
                    wrap
                >
                    Programme de révision
                </TextM>
            </HeaderContainerM>
            <View
                style={{
                    flex: 1,
                    alignSelf: "center",
                    width: dimensions.width - 40,
                }}
            >
                <StudyProgramDisplayComponent
                    studyProgram={studyProgramToDisplay}
                    isLoading={isLoading}
                    loadingMessage="Chargement du programme de révision..."
                />
            </View>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        studyPrograms: state.data.studyPrograms.studyPrograms,
        subscribeUserStudyPrograms:
            state.data.formData?.user?.current_study_programs,
        getStudyProgramRequest: state.api.getStudyProgram?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiRequestWithPrerequest,
    apiIdle,
}

const ConnectedLegacyStudyProgramScreen = connect(
    mapStateToProps,
    mapDispatchToProps
)(LegacyStudyProgramScreen)

/**
 * Pont **mode parent seulement** : la route sert aussi l'élève et le tuteur, et l'écran du design
 * system a été dessiné pour le parent.
 */
export default parentOnlyBridge(
    RevisionProgramScreen,
    ConnectedLegacyStudyProgramScreen
)
